import { render, staticRenderFns } from "./TimberTable.vue?vue&type=template&id=6025db20&scoped=true&"
import script from "./TimberTable.vue?vue&type=script&lang=js&"
export * from "./TimberTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025db20",
  null
  
)

export default component.exports